import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#EC1C24" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink href="https://www.facebook.com/pages/Aburiya-Sushi/1136404009798603">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Aburiya SushiJapanese Restaurant Facebook"
              />
            </CFLink>
            {/* <CFLink href="https://www.yelp.ca/biz/sushico-chilliwack">
              <CFImage
                w="40px"
                pr="10px"
                src={yelp}
                alt="Aburiya SushiJapanese Restaurant Yelp"
              />
            </CFLink> */}
            {/* <CFLink href="https://www.zomato.com/vancouver/masita-korean-cuisine-central-burnaby-burnaby">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Aburiya SushiJapanese Restaurant Zomato"
              />
            </CFLink> */}
            {/* <CFLink href="https://www.instagram.com/chilliwacksushico/">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Aburiya SushiJapanese Restaurant Instagram"
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#EC1C24" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink href="https://www.facebook.com/pages/Aburiya-Sushi/1136404009798603">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Aburiya SushiJapanese Restaurant Facebook"
                hover
              />
            </CFLink>
            {/* <CFLink href="https://www.yelp.ca/biz/sushico-chilliwack">
              <CFImage
                w="40px"
                pr="10px"
                src={yelp}
                alt="Aburiya SushiJapanese Restaurant Yelp"
                hover
              />
            </CFLink> */}
            {/* <CFLink href="https://www.zomato.com/vancouver/masita-korean-cuisine-central-burnaby-burnaby">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Aburiya SushiJapanese Restaurant Zomato"
                hover
              />
            </CFLink> */}
            {/* <CFLink href="https://www.instagram.com/chilliwacksushico/">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Aburiya SushiJapanese Restaurant Instagram"
                hover
              />
            </CFLink> */}
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
